import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=54921615&scoped=true&"
import script from "./Preview.vue?vue&type=script&lang=js&"
export * from "./Preview.vue?vue&type=script&lang=js&"
import style0 from "./Preview.vue?vue&type=style&index=0&id=54921615&scoped=true&lang=css&"
import style1 from "./Preview.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54921615",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/dealerdraft/dealerdraft/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
